__turbopack_context__.v({
  "fadeInItems": "Covers-module__9GaL7G__fadeInItems",
  "image": "Covers-module__9GaL7G__image",
  "imageBackground": "Covers-module__9GaL7G__imageBackground",
  "imageWrapper": "Covers-module__9GaL7G__imageWrapper",
  "row": "Covers-module__9GaL7G__row",
  "spacing--lg": "Covers-module__9GaL7G__spacing--lg",
  "spacing--md": "Covers-module__9GaL7G__spacing--md",
  "spacing--sm": "Covers-module__9GaL7G__spacing--sm",
  "spacing--xl": "Covers-module__9GaL7G__spacing--xl",
  "spacing--xs": "Covers-module__9GaL7G__spacing--xs",
  "spacing--xxl": "Covers-module__9GaL7G__spacing--xxl",
  "spacing--xxs": "Covers-module__9GaL7G__spacing--xxs",
  "spacing--xxxl": "Covers-module__9GaL7G__spacing--xxxl",
  "spacing--xxxs": "Covers-module__9GaL7G__spacing--xxxs",
});
